export const ar = {
  addWeightProduct: "إضافة منتج وزن",
  weightProduct: "منتج وزن",
  weightProducts: "منتجات وزن",
  standardProducts: "منتجات عاديه",
  localProducts: "منتجات داخليه",
  weightDefinedProducts: "منتجات وزن محدد",
  weightDefinedProduct: "منتج وزن محدد",
  home: "الرئيسية",
  suppliers: "المناديب",
  brands: "العلامات التجارية",
  noBrands: "لا يوجد علامات تجارية",
  itemsSales: "حركه الاصناف",
  editBrand: "تعديل العلامة التجارية",
  deleteBrandConfirmation: "هل أنت متأكد من حذف العلامة التجارية",
  storagePlaces: "المخازن",
  mainStoragePlace: "المخزن الرئيسي",
  inventory: "المخزون",
  transactions: "الفواتير",
  product: "منتج",
  products: "المنتجات",
  payments: "الدفعات",
  payment: "دفعه",
  cashiers: "الكاشيرات",
  paymentHistory: "سجل الدفعات",
  balanceHistory: "سجل الرصيد",
  loading: "جاري التحميل",
  noPaymentsFound: "لا يوجد دفعات",
  tapPlusToAddPayment: "اضغط على + لإضافة دفعة",
  paymentReceived: "تم استلام الدفعة",
  fromDate: "من تاريخ",
  toDate: "إلى تاريخ",
  notes: "ملاحظات",
  clear: "مسح",
  filter: "تصفية",
  edit: "تعديل",
  currentBalance: "الرصيد الحالي",
  supplierNotFound: "المندوب غير موجود",
  ownedToSupplier: "مديونيه للمندوب",
  overpaid: "مديونيه علي المندوب",
  settled: "تم التسوية",
  information: "معلومات",
  created: "تاريخ الاضافة",
  transactionsHistory: "سجل الفواتير",
  noSupplier: "لا يوجد مندوب",
  noProducts: "لا يوجد منتجات",
  productNotFound: "منتج غير موجود",
  errorLoadingTransactions: "فشل في تحميل الفواتير",
  noTransactionsFound: "لا يوجد فواتير",
  newTransaction: "فاتورة جديدة",
  yes: "نعم",
  no: "لا",
  cancel: "إلغاء",
  supplier: "المندوب",
  selectSupplier: "اضغط لاختيار المندوب",
  storagePlace: "المخزن",
  searchSuppliers: "بحث المندوبين",
  done: "تم",
  transactionDate: "تاريخ الفاتورة",
  discount: "الخصم",
  save: "حفظ",
  saving: "جاري الحفظ",
  selectStoragePlace: "اختر المخزن",
  searchStoragePlaces: "بحث المخازن",
  sku: "باركود",
  subTotal: "الاجمالي قبل الخصم",
  total: "الاجمالي",
  summary: "ملخص",
  qty: "الكمية",
  price: "السعر",
  totalCost: "التكلفه الكليه",
  productNotFoundTapToAdd: "غير موجود اضغط للاضافه",
  addProduct: "إضافة منتج",
  enterAmount: "الرجاء إدخال مبلغ",
  enterValidAmount: "الرجاء إدخال مبلغ صحيح",
  paymentRecordedSuccessfully: "تم تسجيل الدفعة بنجاح",
  failedToRecordPayment: "فشل في تسجيل الدفعة",
  addPayment: "إضافة دفعة",
  recordingPaymentFor: "تسجيل دفعة ل",
  paymentDetails: "تفاصيل الدفعة",
  amount: "المبلغ",
  selectDate: "اختار التاريخ",
  paymentDate: "تاريخ الدفعة",
  recordedAt: "وقت التسجيل",
  addNotesAboutPayment: "أضف ملاحظات عن الدفعة",

  paymentEffect: "أثر الدفعة",
  paymentEffectDescription: "هذا الدفعة سيتم طرحها من رصيد المندوب، مما يقلل من المبلغ المدين لهم.",

  welcome: "مرحبا",
  login: "تسجيل الدخول",
  username: "اسم المستخدم",
  password: "كلمه المرور",
  errorLoadingProduct: "فشل في تحميل المنتج",
  noProductFoundWithBarcode: "مفيش منتج ب الباركود ده موجود",
  id: "رقم تعريفي",
  barcode: "باركود",
  productName: "اسم المنتج",
  editProduct: "تعديل المنتج",
  description: "وصف المنتج",
  noProductDescription: "لا يوجد وصف للمنتج.",
  enterProductName: "الرجاء إدخال اسم المنتج",
  enterProductDescription: "الرجاء إدخال وصف المنتج",
  enterBarcode: "الرجاء إدخال الباركود",
  pricing: "التسعير",
  brand: "العلامة التجارية",
  originalPrice: "السعر بدون عروض او خصومات",
  productType: "نوع المنتج",
  baseProduct: "المنتج الاساسي",
  singleProduct: "فردي",
  derivedProducts: "المنتجات المشتقة",
  packOfProduct: "مجموعه او علبه",
  singleOrPack: "فردي او مجموعه",
  valueUnits: "عدد القطع في العلبه او المجموعه",
  baseProductUpc: "باركود المنتج الاساسي",
  enterBrandName: "الرجاء إدخال اسم العلامة التجارية",
  brandName: "اسم العلامة التجارية",
  validationError: "حدث خطأ اثناء التحقق.",
  errorCreatingBrand: "حدث خطأ اثناء انشاء العلامة التجارية.",

  storagePlaceAddress: "عنوان المخزن",
  enterStoragePlaceAddress: "إدخل عنوان المخزن",
  enterStoragePlaceName: "إدخل اسم المخزن",
  newStoragePlace: "مخزن جديد",

  failedToLoadTransactionDetails: "فشل في تحميل تفاصيل الفاتورة",
  goBack: "رجوع",

  completed: "تم",
  cost: "سعر الشراء",
  averageCost: "متوسط التكلفة",
  sellPrice: "سعر البيع",
  lastPurchasePrice: "آخر سعر شراء",
  pricePerKg: "سعر بيع الكيلو",
  costPerKg: "تكلفة الكيلو",
  productionDate: "تاريخ الإنتاج",
  expiryDate: "تاريخ الانتهاء",
  transactionSummary: "ملخص الفاتورة",
  subtotal: "الإجمالي قبل الخصم",
  transactionDetails: "تفاصيل الفاتورة",
  t2feelat: "تققيل ورديات",

  newSupplier: "مندوب جديد",
  editSupplier: "تعديل مندوب",
  name: "الاسم",
  enterSupplierName: "إدخال اسم المندوب",
  phoneNumbers: "ارقام التليفونات",
  enterPhoneNumber: "إدخال رقم التليفون",
  enterNotes: "إدخال ملاحظات",
  addPhoneNumber: "إضافة رقم تليفون",
  update: "تحديث",
  selectBrand: "اختر العلامة التجارية",
  selectCategory: "اختر الفئة",
  searchBrands: "بحث العلامات التجارية",
  enterOrScanBarcode: "إدخال أو امسح الباركود",

  productDetails: "تفاصيل المنتج",
  employees: "الموظفين",

  // Employee related translations
  newEmployee: "موظف جديد",
  editEmployee: "تعديل موظف",
  employeeDetails: "تفاصيل الموظف",
  deleteEmployee: "حذف موظف",
  areYouSureDeleteEmployee: "هل أنت متأكد من حذف",
  delete: "حذف",
  deleteSupplierConfirmation: "هل أنت متأكد من حذف المندوب",
  view: "عرض",
  enterUsername: "أدخل اسم المستخدم",
  enterPassword: "أدخل كلمة المرور",
  enterNewPassword: "أدخل كلمة مرور جديدة",
  error: "خطأ",
  deleteEmployeeConfirmation: "هل أنت متأكد من حذف الموظف",
  deleteBrandError: "فشل في حذف العلامة التجارية. تأكد من عدم وجود منتجات مرتبطة بها.",
  failedToUpdateEmployee: "فشل في تحديث الموظف",
  failedToCreateEmployee: "فشل في إنشاء الموظف",
  failedToDeleteEmployee: "فشل في حذف الموظف",
  createdAt: "تاريخ الإنشاء",
  noEmployeesFound: "لا يوجد موظفين",
  employeeInformation: "معلومات الموظف",
  role: "الدور",
  employeeNotFound: "الموظف غير موجود",
  passwordLeaveEmpty: "كلمة المرور (اتركها فارغة للاحتفاظ بالحالية)",
  updatingEmployee: "جاري تحديث الموظف...",
  confirmDelete: "تأكيد الحذف",
  deleteProductConfirmation: "هل أنت متأكد من حذف هذا المنتج؟",
  deleteProductWithDerived: "هذا المنتج لديه {count} منتجات مشتقة سيتم حذفها أيضاً",
  restoreProduct: "استعادة المنتج",
  restoreProductConfirmation: "هل أنت متأكد من استعادة هذا المنتج؟",
  productDeleted: "تم حذف المنتج",
  productRestored: "تم استعادة المنتج",
  processing: "جاري المعالجة.",
  deleteEmployeeConfirm: "هل أنت متأكد من حذف الموظف",
  add: "إضافة",
  searchEmployees: "البحث عن الموظفين...",
  usernameRequired: "اسم المستخدم مطلوب",
  passwordMinLength: "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
  roleRequired: "الدور مطلوب",
  success: "نجح",
  employeeCreatedSuccessfully: "تم إنشاء الموظف بنجاح",
  ok: "موافق",
  creating: "جاري الإنشاء...",
  createEmployee: "إنشاء موظف",
  employeeUpdatedSuccessfully: "تم تحديث الموظف بنجاح",
  updateEmployee: "تحديث الموظف",
  updatingStatus: "جاري التحديث.",
  cashier: "كاشير",
  employee: "موظف",
  delivery: "توصيل",
  owner: "المالك",
  admin: "مدير",
  worker: "عامل",
  balances: "الخزنه",
  balance: "الرصيد",
  expenses: "المصاريف",
  noShifts: "لا يوجد وردية",
  shifts: "ورديات",
  newShift: "وردية جديدة",
  addShift: "إضافة وردية",
  editShift: "تعديل وردية",
  selectEmployee: "اختر الموظف",
  startTime: "وقت البدء",
  endTime: "وقت الانتهاء",
  cash: "نقدي",
  visa: "فيزا",
  card: "فيزا",
  egp: "ج.م",
  wallet: "محفظة",
  balance_transfer: "تحويل رصيد",
  sale: "بيع",
  manual_deposit: "إيداع يدوي",
  shift_settlement: "تسوية وردية",
  expense: "مصروفات",
  salary: "راتب",
  supplier_payment: "دفعة مورد",
  customer_payment: "دفعة مورد",
  balanceBefore: "الرصيد قبل",
  balanceAfter: "الرصيد بعد",
  noTransactions: "لا يوجد حركات",
  addExpense: "إضافة مصروف",
  editExpense: "تعديل المصروف",
  deleteExpenseConfirmation: "هل أنت متأكد من حذف هذا المصروف؟",
  paymentSource: "خصم من",
  addNotePlaceholder: "إضافة ملاحظة.",
  required: "مطلوب",
  category: "الفئة",
  date: "التاريخ",
  all: "الكل",
  from: "من",
  to: "إلى",
  filters: "تصفيه",
  clearFilters: "مسح الفلاتر",
  addFirstExpense: "أضف أول مصروف لك",
  account: "حساب",
  searchProducts: "بحث عن المنتجات",
  selectedProducts: (count: number) => `المحددة (${count})`,
  noSelectedProducts: "لا توجد منتجات محددة",
  searchByProductName: "ابحث باسم المنتج",
  searchProductsToGetStarted: "ابحث عن المنتجات للبدء",
  searchByNameOrBrand: "ابحث بالاسم أو العلامة التجارية",
  noProductsFound: "لم يتم العثور على منتجات",
  tryDifferentSearchTerms: "جرب مصطلحات بحث مختلفة",
  search: "بحث",
  optional: "اختياري",
  enterSalary: "أدخل الراتب",
  theSalary: "الراتب",
  addBalance: "إضافة رصيد",
  confirm: "تأكيد",
  cashAndTransfers: "تحويلات و محفظه",
  walletTransfer: "تحويل محفظه",
  wallet_transfer: "تحويل محفظه",
  customer_return: "مرتجع من العميل",
  walletReceive: "استلام محفظه",
  walletCharge: "شحن",
  transfer: "تحويل",
  transferDetails: "تفاصيل التحويل",
  transferHistory: "سجل التحويلات",
  noTransferHistory: "لا يوجد تحويلات",
  receive: "استلام",
  walletTransferNote: "تحويل من المحفظه.",
  walletReceiveNote: "استلام في محفظه.",
  walletTransferAmount: "المبلغ المحول من المحفظه.",
  receivedAmount: "المبلغ المستلم",
  balanceType: "نوع الخزنه",
  now: "الآن",
  apply: "تطبيق",
  takePhoto: "التقاط صورة",
  chooseFromLibrary: "الاختيار من الاستوديو",
  cameraPermissionDenied: "تم رفض إذن الكاميرا",
  newBrand: "علامة تجارية جديدة",
  barcodeCopied: "تم نسخ الباركود",
  barcodeNotAvailable: "الباركود غير متاح",
  enterAtLeastThreeCharacters: "ادخل ثلاث حروف على الأقل",
  somethingWentWrong: "حدث خطأ",
  file1mbSizeExceeded: "حجم الملف يتجاوز 1 ميجابايت",
  blockToUpdate: "يجب عليك تحديث التطبيق للمتابعه",
  updateRequired: "يجب عليك تحديث التطبيق للمتابعه",
  updating: "جاري التحديث...",
  updateProgress: "تقدم التحديث",
  updateFailed: "فشل التحديث",
  retry: "إعادة المحاولة",
  checkingForUpdates: "جاري فحص التحديثات...",
  noUpdatesAvailable: "لا توجد تحديثات متاحة",
  updateReady: "التحديث جاهز للتثبيت",
  later: "لاحقاً",
  install: "تثبيت",
  updateDownloaded: "تم تحميل التحديث",
  reloadApp: "إعادة تشغيل التطبيق",
  reloadNow: "إعادة التشغيل الآن",
  pendingUpdate: "تحديث في الانتظار",
  updateDownloadProgress: "جاري تحميل التحديث",
  pleaseWait: "يرجى الإنتظار.",
  manualBalanceTransaction: "عمليه خزنه يدويه.",
  manualBalanceTransactionType: "نوع العمليه",
  deposite: "إيداع",
  withdraw: "سحب",
  addOptionalNote: "إضافة ملاحظة (اختياري)",
  chooseAnAction: "اختر إجراء",
  nextInSequence: "الباركود التالي",

  STANDARD_PRODUCT: "عادي",
  LOCAL_PRODUCT: "داخلي",
  WEIGHT_PRODUCT: "وزن",

  standardProductHint: "المنتج العادي يحمل باركود من الشركه المصنعه.",
  localProductHint: "المنتج الداخلي يطبع له باركود داخلي يطبع بواسطه المحل عباره عن ١٣ رقم يبدأ ب ٢١",
  weightProductHint: `.المنتج الداخلي وزن هو منتج داخلي له باركود يطبع بواسطه المحل عباره عن ١٣ رقم يبدأ ب ٢٠ التسعير ب الكيلو جرام و اي خصومات تطبق علي المنتجات المشتقه`,

  weight: "وزن",
  gms: "جرام",
  kg: "كج",
  grams: "جرام",
  enterWeight: "أدخل الوزن",
  weightInGrams: "الوزن بالجرام",
  updateWeight: "تحديث الوزن",
  piece: "قطعة",
  transferProducts: "نقل المنتجات",
  fromStoragePlace: "من المخزن",
  toStoragePlace: "الى المخزن",
  addNotesAboutTransfer: "أضف ملاحظات عن النقل",

  areYouSure: "هل أنت متأكد من إجراء هذا الإجراء؟",

  // Receipt related
  receiptDetails: "تفاصيل الفاتورة",
  receiptNumber: "رقم الفاتورة",
  receiptNotFound: "الفاتورة غير موجودة",
  failedToLoadReceipt: "فشل في تحميل الفاتورة",
  items: "العناصر",
  paymentMethod: "طريقة الدفع",
  paid: "المدفوع",
  remaining: "المتبقي",
  tax: "الضريبة",

  // Shift related
  shiftDetails: "تفاصيل الوردية",
  shiftNumber: "رقم الوردية",
  shiftNotFound: "الوردية غير موجودة",
  receipts: "الفواتير",
  noReceiptsFound: "لا يوجد فواتير",
  loadMore: "تحميل المزيد",
  noMoreReceipts: "لا يوجد المزيد من الفواتير",
  noMoreShifts: "لا يوجد المزيد من الورديات",
  inProgress: "جاري التنفيذ",
  ended: "انتهى",
  pendingConfirmation: "بانتظار التأكيد",
  confirmShift: "تأكيد الوردية",
  expected: "المتوقع",
  actual: "الفعلي",
  variance: "الفرق",
  confirmationNote: "ملاحظة التأكيد",
  addConfirmationNote: "أضف ملاحظة (اختياري)",
  shiftConfirmed: "تم تأكيد الوردية",
  confirming: "جاري التأكيد...",
  shiftNotPending: "الوردية ليست قيد الانتظار",
  start: "البدء",
  end: "الانتهاء",
  removeBackground: "إزالة الخلفية",
  failedToRemoveBackground: "فشل في إزالة الخلفية",
  previewImage: "معاينة الصورة",
  uploading: "جاري الرفع...",
  customers: "العملاء",
  customerDetails: "تفاصيل العميل",
  newCustomer: "عميل جديد",
  editCustomer: "تعديل عميل",
  selectCustomer: "اختر العميل",
  customerLookup: "بحث العملاء",
  searchByName: "بحث بالاسم",
  searchByPhone: "بحث برقم الهاتف",
  noCustomerTransactions: "لا يوجد حركات للعميل.",
  addCustomerTransaction: "إضافة حركة",
  customerTransactions: "معاملات",
  totalOrders: "إجمالي الطلبات",
  totalSpent: "إجمالي الإنفاق",
  totalExpenses: "إجمالي المصاريف",
  expensesCount: "عدد المصاريف",
  totalTransactions: "إجمالي الفواتير",
  transactionsCount: "عدد الفواتير",
  purchases: "المشتريات",
  returns: "المرتجعات",
  net: "الصافي",
  lastOrder: "آخر طلب",
  never: "أبدا",
  PAYMENT: "دفعة",
  ORDER_DEBT: "مشتريات",
  REFUND: "مرتجع",
  ADJUSTMENT: "تسويه",
  receipt: "الفاتورة",
  receiptLookup: "بحث عن فاتورة",
  selectReceipt: "اختر الفاتورة",
  noReceipts: "لا توجد فواتير",
  searchByReceiptHash: "ابحث برقم الفاتورة أو الهاش",
  inventoryMovements: "حركه الاصناف",
  selectProduct: "اختر المنتج",
  currentInventory: "المخزون الحالي",
  totalSales: "إجمالي المبيعات",
  averagePrice: "متوسط السعر",
  profit: "الأرباح التقديرية",
  barcodeScanner: "ماسح الباركود",
  lookingUpProduct: "جاري البحث عن المنتج...",
  typeOrPasteBarcode: "اكتب أو الصق رقم الباركود",
  submit: "إرسال",
  pasteWithKeyboardTip: "💡 يمكنك لصق الباركود باستخدام Ctrl+V",
  pressEscToClose: "اضغط ESC للإغلاق",
  cameraNotAvailableOnWeb: "الكاميرا غير متاحة على الويب. الرجاء إدخال الباركود يدوياً.",
  scanBarcode: "مسح الباركود",
  searchForAnotherBarcode: "بحث عن باركود جديد",
  workInProgress: "تحت التنفيذ",
  menu: "المنيو",
  orders: "الطلبات",

  announcements: "الإعلانات",
  announcementDescription: "وصف الإعلان",
  noAnnouncements: "لا يوجد إعلانات",
  sections: "الاقسام",
  noSections: "لا يوجد اقسام",
  collections: "المجموعات",
  noCollections: "لا يوجد مجموعات",
  createAnnouncement: "إنشاء إعلان",
  title: "العنوان",
  section: "قسم",
  collection: "مجموعة",
  selectSection: "اختر القسم",
  selectCollection: "اختر المجموعة",
  create: "إنشاء",
  imageSelected: "تم اختيار الصورة",
  tapToUploadImage: "اضغط لرفع صورة",
  pleaseSelectImage: "الرجاء اختيار صورة",
  newSection: "قسم جديد",
  editSection: "تعديل القسم",
  addCollection: "إضافة مجموعة",
  newCollection: "مجموعة جديدة",
  editCollection: "تعديل المجموعة",
  editAnnouncement: "تعديل الإعلان",
  deliveryAreas: "مناطق التوصيل",
  areas: "مناطق",
  noAreas: "لا يوجد مناطق",
  editDeliveryArea: "تعديل منطقة التوصيل",
  addDeliveryArea: "إضافة منطقة التوصيل",
  deliveryAreaName: "اسم منطقة التوصيل",
  priority: "الاولوية",
  deliveryFees: "رسوم التوصيل",
  color: "اللون",
  addresses: "العناوين",
  noAddresses: "لا يوجد عناوين",
  addressArea: "المنطقة",
  street: "الشارع",
  building: "المبنى",
  floor: "الطابق",
  apartment: "الشقة",
  addressDetails: "تفاصيل العنوان",
  addAddress: "إضافة عنوان",
  editAddress: "تعديل العنوان",
  saveAddress: "حفظ العنوان",
  addressLabel: "تسمية العنوان",
  area: "المنطقة",
  flat: "الشقة",
  addressInstructions: "تعليمات التوصيل",
  deleteAddress: "حذف العنوان",
  confirmDeleteAddress: "هل أنت متأكد من حذف العنوان؟",
  locationUrl: "رابط الموقع (Google Maps)",

  // Order management
  orderDetails: "تفاصيل الطلب",
  orderNumber: "رقم الطلب",
  orderSource: "مصدر الطلب",
  orderStatus: "حالة الطلب",
  activityLog: "سجل النشاط",
  orderItems: "عناصر الطلب",
  deliveryInfo: "معلومات التوصيل",
  deliveryInstructions: "تعليمات التوصيل",
  noOrders: "لا توجد طلبات",
  searchByOrderNumber: "بحث برقم الطلب",
  filterByStatus: "تصفية حسب الحالة",
  filterBySource: "تصفية حسب المصدر",
  unitPrice: "سعر الوحدة",
  lineTotal: "الإجمالي",
  deliveryFee: "رسوم التوصيل",
  orderSummary: "ملخص الطلب",
  lastUpdated: "آخر تحديث",

  // Order sources
  sourceApp: "التطبيق",
  sourcePhone: "هاتف",
  sourceWhatsapp: "واتساب",

  // Order statuses
  pending: "قيد الانتظار",
  confirmed: "مؤكد",
  preparing: "قيد التحضير",
  out_for_delivery: "في الطريق للتوصيل",
  delivered: "تم التوصيل",
  cancelled: "ملغي",
  rejected: "مرفوض",
  delivery_failed: "فشل التوصيل",

  // Status actions
  confirmOrder: "تأكيد الطلب",
  rejectOrder: "رفض الطلب",
  cancelOrder: "إلغاء الطلب",
  startPreparing: "بدء التحضير",
  markOutForDelivery: "في الطريق",
  markDelivered: "تم التوصيل",
  markDeliveryFailed: "فشل التوصيل",
  rejectionReason: "سبب الرفض",
  enterRejectionReason: "أدخل سبب الرفض",

  // Activity log
  changedBy: "تم التغيير بواسطة",
  statusChanged: "تم تغيير الحالة",
  itemsChanged: "تم تغيير العناصر",
  addressChanged: "تم تغيير العنوان",
  discountChanged: "تم تغيير الخصم",
  orderCreated: "تم إنشاء الطلب",
  noActivityYet: "لا توجد أنشطة حتى الآن",
  changeHistory: "سجل التغييرات",
  newOrder: "طلب جديد",
  selectAddress: "اختر العنوان",
  selectProducts: "اختر المنتجات",
  quantity: "الكمية",
  createOrder: "إنشاء الطلب",
  orderCreatedSuccessfully: "تم إنشاء الطلب بنجاح",
  noAddressesForCustomer: "لا توجد عناوين لهذا العميل",
  pleaseSelectCustomerFirst: "الرجاء اختيار العميل أولاً",
  fillAllRequiredFields: "الرجاء ملء جميع الحقول المطلوبة",
  phone: "رقم الهاتق",
  // Order Editing
  editOrder: "تعديل الطلب",
  saveChanges: "حفظ التغييرات",
  orderUpdated: "تم تحديث الطلب بنجاح",
  cannotEditOrder: "لا يمكن تعديل هذا الطلب",
  orderMustBePendingOrConfirmed: "يجب أن يكون الطلب قيد الانتظار أو مؤكد أو قيد التحضير للتعديل",
  editPreparingWarning: "هذا الطلب قيد التحضير. هل تريد التعديل عليه؟",
  editOutForDeliveryWarning: "هذا الطلب في الطريق للتوصيل. هل تريد التعديل عليه؟",
  editOrderWarning: "هل تريد التعديل على هذا الطلب؟",
  cancelInFlightWarning: "هذا الطلب قيد التوصيل. هل تريد إلغائه؟",
  keepOrder: "إبقاء الطلب",

  // Transaction editing
  editTransaction: "تعديل الفاتورة",
  cannotEditTransaction: "لا يمكن تعديل هذه الفاتورة",
  transactionEdited: "فاتوره معدله",
  transactionCancelled: "فاتوره ملغيه",
  active: "نشط",
  replacedBy: "تم استبدالها بـ",
  originalTransaction: "نسخه قديمه",
  newVersion: "نسخة جديدة",
  confirmCancelTransaction: "تأكيد إلغاء الفاتورة",
  cancelTransaction: "إلغاء الفاتورة",
  filterTransactions: "تصفية الفواتير",
  dateRange: "الفترة الزمنية",
  status: "الحالة",

  // Inventory Tracking
  SALE: "بيع",
  RESTOCK: "شراء",
  PURCHASE: "شراء", // Keep for compat if needed, but RESTOCK is main
  RETURN: "مرتجع",
  soldAt: "بيع بسعر",
  totalSale: "إجمالي البيع",
  boughtAt: "شراء بسعر",
  unitCost: "تكلفة الوحدة",
  movementHistory: "سجل حركة الصنف",
  noMovements: "لا توجد حركات في هذه الفترة",

  // Inventory Management
  adjustStock: "تعديل المخزون",
  adjustStockReason: "سبب التعديل",
  adjustments: "التسويات",
  adjustmentHistory: "سجل التسويات",
  noAdjustments: "لا توجد تسويات",
  newQuantity: "الكمية الجديدة",
  lowStockThreshold: "حد انخفاض المخزون",
  setLowStockThreshold: "تعيين حد انخفاض المخزون",
  clearLowStockThreshold: "مسح حد انخفاض المخزون",
  clearLowStockThresholdInfo: "اترك الحقل فارغاً لمسح حد انخفاض المخزون. سيتم عرض تحذير عندما تكون الكمية أقل من هذا الحد.",
  inventoryDetails: "تفاصيل المخزون",
  costAndPricing: "التكلفة والتسعير",
  stockLevels: "مستويات المخزون",
  costNote: "يتم تحديث سعر الشراء من خلال فواتير الشراء من الموردين",
  lowStockWarning: "مخزون منخفض - الكمية الحالية أقل من الحد المحدد",
  inactive: "غير نشط",
  deleted: "محذوف",
  deletedProducts: "المنتجات المحذوفة",
  viewBaseProduct: "عرض المنتج الأساسي",
  today: "اليوم",
  week: "أسبوع",
  month: "شهر",
  year: "سنة",
  custom: "مخصص",
  purchaseFrequency: "اتجاه المبيعات",
  noDataAvailable: "لا توجد بيانات",
  maxProductsReached: "الحد الأقصى",
  scaleProducts: "منتجات وزن",
  scaleCode: "كود الميزان",
  scaleSheet: "شيت الميزان",
  downloadScaleSheetSuccess: (count: number) => `تم تحميل ${count} منتج وزن`,
  downloadAvailableOnWeb: "التحميل متاح من نسخة الويب فقط",
  addWeightDefinedProduct: "إضافة منتج وزن محدد",
  WEIGHT_DEFINED_PRODUCT: "وزن محدد",
  useCustomPrice: "سعر مخصص",
  weightVariants: "متغيرات الوزن",
  editWeightDefinedProduct: "تعديل منتج وزن محدد",

  // Transaction Types
  transactionType: "نوع الفاتورة",
  purchaseTransaction: "شراء",
  returnTransaction: "مرتجع للمورد",
  createReturn: "إنشاء مرتجع",

  // Menu Product Edit
  editMenuProduct: "تعديل منتج المنيو",
  listedInApp: "متاح في التطبيق",
  notListedInApp: "غير متاح في التطبيق",
  availableForSale: "متاح للبيع",
  unavailableForSale: "غير متاح للبيع",
  canExceedInventory: "السماح بتجاوز المخزون",
  maxQuantityPerOrder: "الحد الأقصى للطلب الواحد",
  inStock: "متوفر",
  outOfStock: "غير متوفر",
  hidden: "مخفي",
  archived: "مؤرشف",
  tryAdjustFiltersOrAddNewPayment: "حاول تعديل الفلاتر أو إضافة دفعة جديدة",
  tryAgain: "حاول مرة اخري",
  more: "المزيد",
  images: "الصور",
  noImages: "لا يوجد صور",
  deleteImage: "حذف الصورة",
  deleteImageConfirmation: "هل أنت متأكد من حذف هذه الصورة؟",
  failedToDeleteImage: "فشل في حذف الصورة",
  addImage: "إضافة صورة",
  inventoryCollection: "مجموعة المخزون",
  inventoryCollections: "مجموعات المخزون",
  createInventoryCollections: "إنشاء مجموعة مخزون",
  editInventoryCollections: "تعديل مجموعة مخزون",
  noInventoryCollections: "لا توجد مجموعات مخزون بعد",
  searchInventoryCollections: "ابحث عن مجموعة مخزون",
  inventoryCollectionNotFound: "مجموعة المخزون غير موجودة",
  empty: "فارغ",
  notPartOfAnyInventoryCollections: "غير موجود في اي مجموعة مخزون",
  baseProductsOnly: "منتجات اساسيه فقط",
  inventoryReport: "تقرير المخزون",
  salesDetails: "تفاصيل المبيعات",
  totalReceipts: "عدد الإيصالات",
  applyFilters: "تطبيق التصفيه",
  allProducts: "الكل",
  noData: "لا توجد بيانات",
  generateReport: "إنشاء التقرير",
  purchased: "تم الشراء",
  purchasedQty: "كمية المشتريات",
  purchasedCost: "تكلفة المشتريات",
  posSales: "مبيعات الكاشير",
  onlineSales: "مبيعات اونلاين",
  totalSold: "إجمالي المبيعات",
  totalRevenue: "إجمالي الإيرادات",
  currentStock: "المخزون الحالي",
  currentValue: "القيمة الحالية",
  avgCost: "متوسط التكلفة",
  noReportData: "لا توجد بيانات لهذا التقرير",
  selectDateRange: "اختر الفترة الزمنية",
  selectFilter: "اختر طريقة التصفية",
  baseSales: "مبيعات المنتج الاساسي",
  aggregatedTotal: "الإجمالي (اساسي + مشتق)",

  // Inventory normalization
  normalizeStoragePlaces: "تسوية المخزن",
  noProductsNeedNormalization: "لا توجد منتجات تحتاج إلى تسوية في هذا المخزن",
  normalizeProduct: "تسوية المنتج",
  willBeMergedInto: "سيتم دمجها في",
  afterNormalization: "بعد التسوية",

  // Customer Returns
  customerReturns: "مرتجعات العملاء",
  newReturn: "مرتجع جديد",
  returnDetails: "تفاصيل المرتجع",
  returnNumber: "رقم المرتجع",
  returnReason: "سبب المرتجع",
  returnQuantity: "الكمية المرتجعة",
  returnWeight: "الوزن المرتجع",
  refundMethod: "طريقة الاسترداد",
  refundTotal: "إجمالي الاسترداد",
  receiptLinked: "مرتبط بفاتورة",
  standalone: "مستقل",
  selectReturnType: "اختر نوع المرتجع",
  enterReturnReason: "أدخل سبب المرتجع",
  cancelReturn: "إلغاء المرتجع",
  confirmCancelReturn: "هل أنت متأكد من إلغاء هذا المرتجع؟ سيتم عكس الاسترداد.",
  returnCancelled: "تم إلغاء المرتجع",
  returnProcessed: "تم تسجيل المرتجع بنجاح",
  noReturns: "لا يوجد مرتجعات",
  addFirstReturn: "أضف أول مرتجع",
  returnItem: "عنصر مرتجع",
  returnItems: "عناصر المرتجع",
  linkedReceipt: "فاتورة مرتبطة",
  linkedOrder: "طلب مرتبط",
  selectOrder: "اختر طلب",
  orderLookup: "بحث عن طلب",
  returnedAt: "تاريخ المرتجع",
  cancelledAt: "تاريخ الإلغاء",
  cancelledBy: "ألغي بواسطة",

  // order source
  whatsapp: "واتس اب",
  app: "تطبيق",
  pos: "كاشير",
  manual: "يدوي",

  // config editor
  config: "إعدادات التطبيق",
  channel: "القناة",
  maintenance: "وضع الصيانة",
  busy: "مشغول",
  configMessage: "رسالة",
  configMessagePlaceholder: "اكتب رسالة تظهر للعملاء...",
  version: "الإصدار",
  latestVersion: "أحدث إصدار",
  minimumVersion: "الحد الأدنى",
  storeLinks: "روابط المتجر",
  saved: "تم الحفظ بنجاح",
  crossEnvWarning: "تحذير: أنت تعدل قناة مختلفة عن البيئة الحالية",
  developmentChannel: "تطوير",
  stagingChannel: "تجريبي",
  productionChannel: "إنتاج",
  errorLoading: "خضأ في التحميل",

  // notifications
  notifications: "الإشعارات",
  sendNotification: "إرسال إشعار",
  notificationTitle: "العنوان",
  notificationBody: "الرسالة",
  notificationReachable: "قابل للوصول",
  notificationNotReachable: "غير قابل للوصول",
  notificationNotOptedIn: "غير مشترك في الإشعارات",
  notificationEligible: "سيستلم الإشعار",
  notificationNoRecipients: "لا يوجد مستلمون مؤهلون",
  notificationSendLimit: "العدد يتجاوز الحد المسموح",
  notificationSend: "إرسال",
  notificationAccepted: "تم القبول",
  notificationRejected: "مرفوض",
  notificationSkipped: "تم تخطيه",
  confirmSendMessage: "هل أنت متأكد من إرسال الإشعار؟",
  notificationAudience: "الجمهور المستهدف",
  notificationAudienceAll: "الجميع",
  notificationAudienceRegistered: "العملاء فقط",
  notificationAudienceUnregistered: "الزوار",
  notificationAudienceGroup: "مجموعة",
  notificationAudienceCustomer: "عميل",
  notificationExcluded: "مستبعد",
  notificationSendHistory: "سجل الإرسال",
  notificationHistoryEmpty: "لا يوجد سجل إرسال بعد",
  notificationSelectGroup: "اختر المجموعة",
  notificationGroups: "مجموعات الإشعارات",
  notificationNewGroup: "مجموعة جديدة",
  notificationEditGroup: "تعديل المجموعة",
  notificationGroupName: "اسم المجموعة",
  notificationGroupMembers: "الأعضاء",
  notificationGroupAddMember: "إضافة عضو",
  notificationGroupRemoveMember: "إزالة العضو",
  notificationNoGroups: "لا توجد مجموعات بعد",
  notificationNoMembers: "لا يوجد أعضاء بعد",
  notificationDeleteGroupConfirmation: "سيتم حذف المجموعة. هل أنت متأكد؟",

  // expense categories
  expenseCategories: "فئات المصاريف",
  newExpenseCategory: "فئة جديدة",
  editExpenseCategory: "تعديل الفئة",
  categoryName: "اسم الفئة",
  noCategories: "لا توجد فئات",
  deleteExpenseCategoryConfirmation: "هل أنت متأكد من حذف هذه الفئة؟",
  uncategorized: "غير مصنف",
  noExpenses: "لا توجد مصروفات",
  noSuppliersFound: "لا يوجد موردين",
}
